import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

export const UPGRADE_TO_BUSINESS_ROOTUI_TYPE = 'UPGRADE_TO_BUSINESS_CONTAINER';

type props = {
  onClose: () => void;
  location?: 'default' | 'dashboard';
};

export const BusinessUpgradeUpsertAction = createAction(rootUiActions.createDialog.toString(), (props: props) =>
  rootUiTypes.mkRootUiData({
    type: UPGRADE_TO_BUSINESS_ROOTUI_TYPE,
    id: 'upgrade-to-business',
    props: ImmutableMap({
      modalType: 'dialog',
      onClose: props.onClose,
      location: props.location || 'default',
    }),
  }),
);
